import React from 'react'
import DotSeparatedInfo from './DotSeparatedInfo'
import { ClassNameProps } from 'types/utilities'
import { MAX_PLAYERS_PER_WATCHLIST } from 'constants/watchlists'
import { useTranslation } from 'react-i18next'

interface Props extends ClassNameProps {
  totalPlayers?: number
  avgSinglesWtn?: string
  minSinglesWtn?: string
  maxSinglesWtn?: string
}

const WatchlistStats = ({
  className,
  totalPlayers,
  avgSinglesWtn,
  minSinglesWtn,
  maxSinglesWtn,
}: Props) => {
  const { t: tWatchlists } = useTranslation('strWatchlists')

  let info: string[] = []
  if (typeof totalPlayers === 'number')
    info.push(
      tWatchlists('detail.count', {
        count: totalPlayers,
        max: MAX_PLAYERS_PER_WATCHLIST,
      })
    )
  if (avgSinglesWtn)
    info.push(
      tWatchlists('common.averageSinglesWtn', {
        average: avgSinglesWtn,
      })
    )
  if (minSinglesWtn)
    info.push(
      tWatchlists('common.minSinglesWtn', {
        min: minSinglesWtn,
      })
    )
  if (maxSinglesWtn)
    info.push(
      tWatchlists('common.maxSinglesWtn', {
        max: maxSinglesWtn,
      })
    )

  return <DotSeparatedInfo infoList={info} className={className} />
}

export default WatchlistStats
